import { render, staticRenderFns } from "./DatiApp.vue?vue&type=template&id=29d71101&"
import script from "./DatiApp.vue?vue&type=script&lang=js&"
export * from "./DatiApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports